import { useParams } from 'react-router';

import useBrains from './useBrains';

export const useIsStartingNode = (nodeId?: string) => {
  const { brainId } = useParams();
  const { brain } = useBrains(brainId);

  return Boolean(brain?.starting_node_id) && nodeId === brain?.starting_node_id;
};
